import { render } from "./ScheduleView.vue?vue&type=template&id=8c535444&scoped=true"
import script from "./ScheduleView.vue?vue&type=script&lang=js"
export * from "./ScheduleView.vue?vue&type=script&lang=js"

import "./ScheduleView.vue?vue&type=style&index=0&id=8c535444&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c535444"]])

export default __exports__